/**
 * Text for one variant in Add Entry's variant picker.
 *
 * A variant's label can be a long list (a labour rate's region tiers run to
 * several city names), and a native select popup is as wide as its longest
 * option, which at phone width is wider than the dialog. The label is cut to
 * `MAX_VARIANT_LABEL_LENGTH` characters and the price stays after it, so the
 * price is never the part that is cut. `isTruncatedVariantLabel` says when the
 * full label has to be shown elsewhere.
 */

export const MAX_VARIANT_LABEL_LENGTH = 40;

export function isTruncatedVariantLabel(label: string): boolean {
	return label.length > MAX_VARIANT_LABEL_LENGTH;
}

export function variantOptionLabel(label: string, priceText: string): string {
	const shown = isTruncatedVariantLabel(label)
		? `${label.slice(0, MAX_VARIANT_LABEL_LENGTH - 1).trimEnd()}…`
		: label;
	return `${shown} · ${priceText}`;
}
